import { buildQueryContext, QueryFormData } from '@superset-ui/core';

export default function buildQuery(formData: QueryFormData) {
  const { metric, sort_by_metric } = formData;
  const { groupby } = formData;
  if (formData.showGoldStandard) {
    // eslint-disable-next-line no-param-reassign
    formData.groupby = [groupby, formData.goldStandardCondition[0].subject];
  }
  return buildQueryContext(formData, baseQueryObject => [
    {
      ...baseQueryObject,
      ...(sort_by_metric && { orderby: [[metric, false]] })
    },
  ]);
}
